<script setup>
import loadingSpinner from "@/views/loadingSpinner.vue"

import { computed, onUnmounted } from 'vue'
import { useUiStore } from '@/stores/ui'
const uiStore = useUiStore()


const loadingText = computed(() => {
  return uiStore.loadingScreenText || ''
})

const loadingSubText = computed(() => {
  return uiStore.loadingScreenSubText || ''
})

onUnmounted(() => {
  uiStore.setLoadingScreenText("")
  uiStore.setLoadingScreenSubText("")
})
</script>

<template>
  <div class="colCenter h-full">
    <div style="margin-top: 35vh;"></div>
    <text-item :txt="loadingText" styles="main-h font-xl"/>
    <div class="mtop-10"></div>
    <text-item :txt="loadingSubText" styles="main-m font-l"/>
    <div class="mtop-30"></div>
    <loadingSpinner/>
  </div>
</template>